// Styles for CardDetailsContent

import styled from 'styled-components';
import { baseVariables, toRem } from '@marriott/mi-ui-library';

export const StyledCardDetailsContent = styled.div`
  .collapsed {
    border-top: none !important;
  }

  /* RTE content spacing - uses :has() for parent-child selectors */
  p:has(> span.t-subtitle-m),
  p:has(> span.content-margin) {
    margin-bottom: ${toRem(8)};
  }

  li:has(> span.t-font-s) {
    margin-bottom: ${toRem(4)};
  }

  /* Custom table layout - responsive two-column display */
  table {
    vertical-align: top;
    width: 100%;
    display: inline-table;

    @media ${baseVariables.mediaQuery.lg} {
      width: 49%;
      display: inline-block;
    }

    td {
      width: 57%;
      padding: 0 ${toRem(25)} ${toRem(8)} 0;
      vertical-align: top;

      @media ${baseVariables.mediaQuery.md} {
        padding-right: ${toRem(28)};
      }
    }
  }

  /* Number font family override */
  .number {
    font-family: ${baseVariables.font.fontSwissCondensed};
  }

  /* Remove bottom margin from points paragraphs */
  .points p {
    margin-bottom: 0;
  }
`;
